<template>
  <div class=" border-1 p-3 h-100">
    <div class="ps-4 table-responsive">

      <div class="d-flex justify-content-end pe-4 mb-2">
        <div class="input-group" style="max-width: 320px;">
          <span class="input-group-text">
            <i class="bi bi-search"></i>
          </span>
          <input type="text" class="form-control" placeholder="Nombre de la categoria" v-model="busqueda"
            @input="Filtro">
        </div>
      </div>

      <div class="table-responsive mx-2 mt-2 py-3">
        <table class="table table-bordered">
          <thead class="reducirTamaño">
            <tr class="bg-solimano text-white text-center text-nowrap">
              <th scope="col">ORDEN</th>
              <th scope="col">CATEGORIA</th>
              <th scope="col">LINK</th>
              <th scope="col">DETALLE</th>
              <th scope="col">CREACION</th>
              <th scope="col">ACTUALIZACION</th>
              <th scope="col"><i class="bi bi-boxes fs-5"></i></th>
            </tr>
          </thead>

          <tbody class="text-nowrap text-center texto-fini align-middle">
            <tr v-if="loading">
              <td colspan="7" class="text-center" style="height: 220px;">
                <div class="d-flex flex-column align-items-center justify-content-center h-100">
                  <div class="spinner-border text-warning" style="width: 3rem; height: 3rem;"></div>
                  <div class="mt-3 text-secondary fw-semibold fs-6">
                    Filtrando información...
                  </div>
                </div>
              </td>
            </tr>
            <tr class="reducirTamaño" v-else v-for="(lista, index) in paginatedLista" :key="index">
              <td>{{ lista.catOrden }}</td>

              <td class="text-start">
                <i :class="lista.nomIcono" class="ms-1 me-3"></i>
                <span>{{ lista.catNombre }}</span>
              </td>

              <td class="text-primary">{{ lista.linkBI.slice(0, 25) }}...</td>

              <td>{{ lista.catDetalle }}</td>
              <td>{{ lista.audfechaCreacion }}</td>
              <td>{{ lista.audfechaActualizacion }}</td>

              <td class="my-0 py-1">
                <button @click="
                  openEditModal(
                    lista.idCategoria,
                    lista.nomCategoria,
                    lista.nomIcono,
                    lista.idIcono,
                    lista.nomModulo,
                    lista.idModulo,
                    lista.catOrden
                  )
                  " class="btn btn-warning mx-1 py-0 px-2 my-0">
                  <i class="bi bi-pencil text-white fs-5"></i>
                </button>

                <button @click="Cambiar(lista.idCategoria)" class="btn btn-light text-danger py-0 px-2 my-0"
                  v-if="lista.estado">
                  <i class="bi bi-toggle-off custom-icon fs-5"></i>

                </button>

                <button v-else @click="Cambiar(lista.idCategoria)" class="btn btn-light text-success py-0 px-2 my-0">

                  <i class="bi bi-toggle-on fs-5"></i>
                </button>

                <button class="btn btn-light text-secondary py-0 px-2 my-0" type="button"
                  @click="copiarAlPortapapeles(lista.linkBI)">
                  <i class="bi bi-copy fs-5"></i>
                </button>

                <button @click="eliminar(lista.idCategoria)" class="btn btn-light text-danger py-0 px-2 my-0">
                  <i class="bi bi-trash3 fs-5"></i>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="pagination-container d-flex justify-content-center align-items-center gap-2 my-3">

        <!-- Ir al inicio -->
        <button class="btn btn-outline-primary btn-sm" @click="currentPage = 1" :disabled="currentPage === 1">
          <i class="bi bi-chevron-double-left"></i>
        </button>

        <!-- Retroceder -->
        <button class="btn btn-outline-primary btn-sm" @click="currentPage--" :disabled="currentPage === 1">
          <i class="bi bi-chevron-left"></i>
        </button>

        <!-- Información -->
        <span class="pagination-info small">
          Página {{ currentPage }} de {{ totalPages }}
        </span>

        <!-- Avanzar -->
        <button class="btn btn-outline-primary btn-sm" @click="currentPage++" :disabled="currentPage === totalPages">
          <i class="bi bi-chevron-right"></i>
        </button>

        <!-- Ir al final -->
        <button class="btn btn-outline-primary btn-sm" @click="currentPage = totalPages"
          :disabled="currentPage === totalPages">
          <i class="bi bi-chevron-double-right"></i>
        </button>

      </div>


      <b-modal ref="editModal" centered title="Editar Módulo" hide-footer hide-close-button
        dialog-class="modal-md-custom">

        <div class="container-fluid">


          <div class="row g-2 mb-3">
            <div v-for="icon in icons" :key="icon.nomIcono"
              class="col-2 icon-box d-flex align-items-center justify-content-center"
              @click="selectIcon(icon.nomIcono, icon.idIcono)" :class="{ selected: icon.nomIcono === selectedIcon }">
              <i :class="icon.nomIcono" class="fs-4"></i>
            </div>
          </div>


          <p class="fw-semibold mb-3">
            Icono seleccionado: <i :class="selectedIcon" class="fs-4"></i>
          </p>


          <div class="mb-3">
            <label class="form-label fw-semibold">Nombre del Módulo:</label>
            <input type="text" class="form-control" v-model="editedIconNameModulo" disabled />
          </div>

          <div class="mb-3">
            <label class="form-label fw-semibold">Nombre de la categoría:</label>
            <input type="text" class="form-control" v-model="editedIconName" />
          </div>

          <div class="mb-3">
            <label class="form-label fw-semibold">Link Power BI:</label>
            <input type="text" class="form-control" v-model="editedIconNameBI" />
          </div>

          <div class="mb-3">
            <label class="form-label fw-semibold">Número de orden:</label>
            <input type="text" class="form-control" v-model="editedNroDeOrden" />
          </div>


          <div class="text-end mt-3">
            <b-button variant="primary" class="me-2" @click="saveChanges">Guardar</b-button>
            <b-button variant="secondary" @click="closeEditModal">Cerrar</b-button>
          </div>

        </div>

      </b-modal>


    </div>
  </div>
</template>

<script>
import Swal from "sweetalert";
import Swal2 from "sweetalert2";
import { mapGetters, mapActions } from "vuex";
export default {
  name: "PowerbyTablaCategoria",

  data() {
    return {
      itemsPerPage: 10, // Cantidad de elementos por página
      currentPage: 1, // Página actual
      selectedIcon: "ninguno",
      icons: [],
      idCategoria: "",
      idModulo: "",
      idIcono: "",
      editedIconName: "",
      editedIconNameBI: "",
      editedIconNameModulo: "",
      editedNroDeOrden: "",
      busqueda: "",
      textoParaCopiar: "",
      catDetalle: "",
      hayResultadosFiltrados: false,
      filtradoCategorias: [], // Almacena los resultados filtrados
      loading: false
    };
  },

  mounted() {
    this.idUsuario = localStorage.getItem("userId");
    this.axios.get(`BIClientes/ListadoIconos`).then((r) => {
      console.log(r.data);
      this.icons = r.data;
    });
  },

  computed: {
    ...mapGetters("acciones", ["ListaModulos", "ListaCategorias"]),

    // Calcula el índice de inicio para la página actual
    startIndex() {
      return (this.currentPage - 1) * this.itemsPerPage;
    },
    // Filtra la lista original para mostrar solo los elementos de la página actual
    paginatedLista() {
      const lista = this.hayResultadosFiltrados
        ? this.filtradoCategorias
        : this.ListaCategorias;
      return lista.slice(this.startIndex, this.startIndex + this.itemsPerPage);
    },
    // Calcula el número total de páginas
    totalPages() {
      const lista = this.hayResultadosFiltrados
        ? this.filtradoCategorias
        : this.ListaCategorias;

      return Math.ceil(lista.length / this.itemsPerPage) || 1;
    },
    filteredCategorias() {
      return this.busqueda.trim() === ""
        ? this.ListaCategorias
        : this.ListaCategorias.filter((categoria) =>
          categoria.catNombre
            .toLowerCase()
            .includes(this.busqueda.toLowerCase())
        );
    },
  },

  created() { },

  methods: {
    ...mapActions("acciones", ["ListarCategorias"]),
    Filtro() {
      this.currentPage = 1;

      // Reiniciar tiempo
      this.tiempoBusqueda = 0;
      clearInterval(this.timerInterval);

      if (this.busqueda.length > 0) {
        const currentDni = this.busqueda;
        this.loading = true;

        // INICIAR CONTADOR
        this.timerInterval = setInterval(() => {
          this.tiempoBusqueda++;
        }, 800);

        const inicio = Date.now(); // <-- Guardamos el momento de inicio

        this.axios
          .get(`BIClientes/BusquedaCategoria?busqueda=${currentDni}`)
          .then((response) => {
            if (currentDni === this.busqueda) {
              this.filtradoCategorias = response.data;
              this.hayResultadosFiltrados = this.filtradoCategorias.length > 0;
            }
          })
          .catch((error) => {
            console.log(error);
          })
          .finally(() => {
            clearInterval(this.timerInterval);

            // Tiempo transcurrido
            const tiempo = Date.now() - inicio;

            // Garantizar spinner mínimo de 800ms
            const restante = Math.max(0, 800 - tiempo);

            setTimeout(() => {
              this.loading = false;
            }, restante);
          });

      } else {
        this.hayResultadosFiltrados = false;
        this.filtradoCategorias = [];
        this.loading = false;
      }
    },



    eliminar(id) {
      this.axios
        .delete(`BIClientes/EliminarCategoria?idcategoria=${id}`)
        .then((r) => {
          console.log(r.data);
          if (r.data) {
            this.ListarCategorias();
            Swal2.fire({
              position: "center",
              icon: "success",
              title: `${r.data}`,
              showConfirmButton: false,
              timer: 3500,
            });
          }
        });
      console.log(id);
    },

    copiarAlPortapapeles(link) {
      const el = document.createElement("textarea");
      el.value = link;
      document.body.appendChild(el);
      el.select();
      document.execCommand("copy");
      document.body.removeChild(el);
      Swal(`Enlace copiado al portapapeles`, "", "success");
    },

    Cambiar(idCategoria) {
      this.axios
        .put(`BIClientes/ModificarEstadoCat?idCategoria=${idCategoria}`)
        .then((r) => {
          console.log(r.data);
          this.ListarCategorias();
        });
    },

    openEditModal(
      idcategoria,
      nombre,
      Icono,
      idIcono,
      nombreModulo,
      idModulo,
      orden
    ) {
      console.log(Icono, nombre, idModulo);
      this.idCategoria = idcategoria;
      this.idModulo = idModulo;
      this.editedIconName = nombre;
      this.selectedIcon = Icono;
      this.idIcono = idIcono;
      this.editedIconNameModulo = nombreModulo;
      this.editedNroDeOrden = orden;
      this.$refs.editModal.show();
    },

    closeEditModal() {
      this.idModulo = "";
      this.editedIconName = "";
      this.idIcono = "";

      this.$refs.editModal.hide();
    },

    saveChanges() {
      const link = this.editedIconNameBI;

      // Expresión regular para extraer el groupId y reportId
      const regex = /groups\/([a-z0-9-]+)\/reports\/([a-z0-9-]+)/;
      const match = link.match(regex);

      // Definir los valores de groupId y reportId
      let grupoid = "";
      let reporteid = "";
      if (match) {
        grupoid = match[1]; // El primer grupo de captura corresponde al groupId
        reporteid = match[2]; // El segundo grupo de captura corresponde al reportId
        console.log("Group ID:", grupoid);
        console.log("Report ID:", reporteid);
      } else {
        console.log("El link de Power BI no es válido.");
      }
      const from = {
        idUsuario: this.idUsuario,
        idIcono: this.idIcono,
        idModulo: this.idModulo,
        idCategoria: this.idCategoria,
        catNombre: this.editedIconName,
        linkBi: this.editedIconNameBI,
        catOrden: this.editedNroDeOrden,
        reporteid: reporteid, // ID del reporte
        grupoid: grupoid,
      };

      console.log(from);
      this.axios.put(`BIClientes/ModificarCategoria`, from).then((r) => {
        console.log(r.data);

        Swal(`Se realizo los cambios`, "", "success");
        this.selectedIcon = "";
        this.ListarCategorias();
      });
      this.closeEditModal();
    },
    changePage(page) {
      this.currentPage = page;
    },

    selectIcon(iconClass, id) {
      this.selectedIcon = iconClass;
      this.idIcono = id;
    },
  },
};
</script>

<style scoped>
.modal-md-custom .modal-dialog {
  max-width: 550px !important;
}

.icon-box {
  border: 1px solid #e3e3e3;
  padding: 6px;
  border-radius: 8px;
  cursor: pointer;
  background: #f8f9fa;
  width: 45px;
  height: 45px;
  transition: 0.2s ease;
}

.icon-box:hover {
  background: #e9ecef;
  transform: scale(1.05);
}

.icon-box.selected {
  border: 2px solid #0d6efd;
  background: #e7f1ff;
  transform: scale(1.07);
}

.icon-box i {
  font-size: 0.9rem !important;
}

.b-modal .modal-header button.close {
  display: none;
}

.bg-solimano {
  text-align: center;
  background: #0080c8;
}

strong {
  font-size: 1.64rem;
  color: black;
}

.letra {
  font-weight: 600;
}

/* .icon-selector {
  display: flex;
  gap: 10px;
} */
.bg-iconos {
  background: #f7f7f7;
}

.icon-selector div {
  cursor: pointer;
  border: 1px solid #ccc;
  border-radius: 5px;
  padding: 2px;
}

.icon-selector div.selected {
  border-color: #007bff;
  /* Color de borde al seleccionar */
}

.icon-selector i {
  font-size: 24px;
  /* Tamaño de los iconos */
}

.tamañoLetra {
  font-size: 0.8rem;
}

.tamañoCuadro {
  font-size: 1.2rem;
  /* Tamaño del texto del label */
}

input[type="text"] {
  border-radius: 8px;
  border: 1px solid #007bff;
  /* Borde azul */
  box-shadow: 0px 0px 5px rgba(0, 123, 255, 0.2);
  /* Sombra ligera */
}



.reducirTamaño {
  font-size: 0.65rem;
}
</style>
